import WebLayout from './MassUpdateCheckboxLayout.web';
import MobileLayout from './MassUpdateCheckboxLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
